import { render, staticRenderFns } from "./OrderDetailInfo.vue?vue&type=template&id=e0af5f38&scoped=true"
import script from "./OrderDetailInfo.vue?vue&type=script&lang=js"
export * from "./OrderDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailInfo.vue?vue&type=style&index=0&id=e0af5f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0af5f38",
  null
  
)

export default component.exports